module.exports = __webpack_public_path__ + "static/media/208right.e6f0df12.jpg";